module.exports = __webpack_public_path__ + "media/images/client-31-177aef10cd511ddf6d4a1e4aabf07fbe.png";